export default "__VITE_ASSET__Dsw03TsF__"